import { __assign, __rest } from "tslib";
import React from "react";
import classNames from "classnames";
import { View } from "../_core/components";
import { Typography } from "../typography";
import { Level } from "../level";
import { useConfig } from "../_util/use-config";
export function Card(_a) {
    var className = _a.className, children = _a.children, props = __rest(_a, ["className", "children"]);
    var classPrefix = useConfig().classPrefix;
    return (React.createElement(View, __assign({ className: classNames(classPrefix + "-card", className) }, props), children));
}
Card.Header = function CardHeader(_a) {
    var className = _a.className, children = _a.children, extra = _a.extra, props = __rest(_a, ["className", "children", "extra"]);
    var classPrefix = useConfig().classPrefix;
    return (React.createElement(View, __assign({ className: classNames(classPrefix + "-card__header", classPrefix + "-hairline--bottom", className) }, props),
        React.createElement(Level, { start: React.createElement(View, null,
                React.createElement(Typography.Heading, { level: 3 }, children)), end: extra })));
};
Card.Body = function CardBody(_a) {
    var className = _a.className, children = _a.children, title = _a.title, subtitle = _a.subtitle, extra = _a.extra, props = __rest(_a, ["className", "children", "title", "subtitle", "extra"]);
    var classPrefix = useConfig().classPrefix;
    return (React.createElement(View, __assign({ className: classNames(classPrefix + "-card__body", className, {
            "with-title": title || subtitle || extra,
        }) }, props),
        (title || subtitle || extra) && (React.createElement(Level, { className: classPrefix + "-card__title", start: React.createElement(View, null,
                React.createElement(Typography.Heading, { level: 3 }, title),
                React.createElement(Typography.Text, { className: classPrefix + "-card__subtitle\" theme=\"light" }, subtitle)), end: extra })),
        children));
};
Card.Footer = function CardFooter(_a) {
    var className = _a.className, props = __rest(_a, ["className"]);
    var classPrefix = useConfig().classPrefix;
    return (React.createElement(View, __assign({ className: classNames(classPrefix + "-card__footer", classPrefix + "-hairline--top", className) }, props)));
};
//# sourceMappingURL=Card.js.map